export default __webpack_public_path__ + "static/media/img-48-ilasiaq.e81df574.jpg";